import { useInfiniteQuery } from 'react-query';

import { ARCHIVED_USERS_KEY, getArchivedUsers } from '@utils/backend-api/organizations';

const useOrganizationArchivedUsers = (searchTerm = '') => {
  return useInfiniteQuery(
    [ARCHIVED_USERS_KEY, searchTerm],
    ({ pageParam = 1 }) => getArchivedUsers({ pageParam, searchTerm }),
    {
      getNextPageParam: (lastPage) => (lastPage.hasNextPage ? lastPage.currentPage + 1 : undefined),
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    }
  );
};

export default useOrganizationArchivedUsers;
